import { useState } from "react"
import { DateType, objectNowDate, validateSearchDate } from "../../utils/dateHandler"
import { useUpdateEffect } from "./useUpdateEffect";

export const useStateSearchDate = () => {
    // 検索日の管理
    const [ searchDate, setSearchDate ] = useState<DateType | null>(objectNowDate()); // 検索日の管理

    // アラートの管理
    const [isInputDateError, setIsInputDateError] = useState(false); // 検索期間設定エラーの状態管理
	const [isAlertOpened, setIsAlertOpened] = useState(false); // アラートの表示の状態管理

    // 検索日の有効値のチェック
    useUpdateEffect(() => {
        const isSuccess = validateSearchDate(searchDate);

        if (!isSuccess) {
            setIsInputDateError(true);
            setIsAlertOpened(true);
            return;
        }

        setIsInputDateError(false);
        setIsAlertOpened(false);
    }, [searchDate]);

    // 検索日を変更した際の処理
    const handleChangeSearchDate = (newValue: DateType | null) => {
        setSearchDate(newValue);
    }

    // エラーのアラートを閉じる際の処理
    const onCloseInputDateErrorAlert = () => {
        setIsAlertOpened(false);
    }

    return {
        searchDate,
        isInputDateError,
        isAlertOpened,
        handleChangeSearchDate,
        onCloseInputDateErrorAlert
    };
}